import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"

const DesignerSection = data => {
  return (
    <div className="row bg-dark rounded mb-medium">
      <div className="col-5">
        <Img fluid={data.imageFluid} />
      </div>
      <div className="col flex flex-col justify-center">
        <p style={{ marginBottom: 0 }}>
          <span className="font-bold">
            {data.title}
            <br />
          </span>
          <span>
            專長: {data.expertise}
            <br />
          </span>
          {data.instagram_id ? (
            <span>
              instagram:{" "}
              <a href={`https://instagram.com/${data.instagram_id}`}>
                @{data.instagram_id}
              </a>
              <br />
            </span>
          ) : null}
          {data.facebook_id && data.facebook_display_name ? (
            <span>
              facebook_id:{" "}
              <a href={`https://facebook.com/${data.facebook_id}`}>
                @{data.facebook_display_name}
              </a>
            </span>
          ) : null}
        </p>
      </div>
    </div>
  )
}

const DesignersPage = ({ data }, location) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout title={siteTitle}>
      <SEO
        title="設計師作品"
        keywords={[
          `外國人風`,
          `造型`,
          `捲髮`,
          `髮型師`,
          `美容院`,
          `美髮師`,
          `台灣`,
          `taiwan`,
          `hairstyles`,
          `台北燙髮`,
          `可愛風`,
          `年輕`,
        ]}
      />
      <article className="post-content page-template no-image">
        <div className="post-content-body">
          <h1>設計師</h1>
          <DesignerSection
            imageFluid={data.designer_wei.childImageSharp.fluid}
            title="1號  嘉偉"
            instagram_id="h.m_wei"
            facebook_id="114038976724368"
            facebook_display_name="h.m_wei"
            expertise="男生剪髮、洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_yi.childImageSharp.fluid}
            title="2號  依蓉"
            instagram_id="h.m_yi"
            facebook_id="101205345429821"
            facebook_display_name="H.M_依蓉"
            expertise="洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_pei.childImageSharp.fluid}
            title="3號  佩玲"
            instagram_id="h.m_pei"
            facebook_id="pei.cheng.18"
            facebook_display_name="HM-Pei Cheng"
            expertise="剪燙染造型、洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_apple.childImageSharp.fluid}
            title="4號  蕙羽"
            instagram_id="h.m_apple0308"
            facebook_id="100109458874805"
            facebook_display_name="H.M_蕙羽"
            expertise="洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_andy.childImageSharp.fluid}
            title="5號  恩蒂"
            instagram_id="h.m_andy.wu.9231"
            facebook_id="103223925221389"
            facebook_display_name="H.M_恩蒂"
            expertise="剪燙染造型、洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_wu.childImageSharp.fluid}
            title="7號  吳老師（主任）"
            expertise="剪燙染造型、洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_qiaohui.childImageSharp.fluid}
            title="8號  僑徽"
            expertise="男生剪髮、洗護理療"
          />
          <DesignerSection
            imageFluid={data.designer_jf.childImageSharp.fluid}
            title="9號  佳芬（店長）"
            instagram_id="h.m.s_jf"
            expertise="女士剪燙染造型、洗護理療"
          />
        </div>
      </article>
    </Layout>
  )
}

const indexQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    designer_wei: file(relativePath: { eq: "designer_wei.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_yi: file(relativePath: { eq: "designer_yi.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_pei: file(relativePath: { eq: "designer_pei.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_apple: file(relativePath: { eq: "designer_apple.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_andy: file(relativePath: { eq: "designer_andy.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_wu: file(relativePath: { eq: "designer_wu.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_qiaohui: file(relativePath: { eq: "designer_qiaohui.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
    designer_jf: file(relativePath: { eq: "designer_jf.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
        original {
          width
        }
      }
    }
  }
`

export default props => (
  <StaticQuery
    query={indexQuery}
    render={data => (
      <DesignersPage location={props.location} data={data} {...props} />
    )}
  />
)
